import { render, staticRenderFns } from "./UiLimitPagination.vue?vue&type=template&id=81f06bf8&lang=pug&"
import script from "./UiLimitPagination.vue?vue&type=script&lang=js&"
export * from "./UiLimitPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports